import { render, staticRenderFns } from "./LidaTable.vue?vue&type=template&id=10e93128&"
import script from "./LidaTable.vue?vue&type=script&lang=js&"
export * from "./LidaTable.vue?vue&type=script&lang=js&"
import style0 from "./LidaTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports